import { connect } from 'react-redux'
import {
  addConso,
  removeConso,
  changeReducConso,
  playTransaction,
  pauseTransaction,
  updateCyclePricing,
  updateCyclePlayers,
  selectCurrentTransaction,
  prepareForPayment
} from 'redux/modules/transaction'
import { showModal } from 'redux/modules/modals'
import TableComponent from '../components/TableComponent.js'

const mapActionCreators = {
  addConso,
  playTransaction,
  pauseTransaction,
  removeConso,
  changeReducConso,
  selectCurrentTransaction,
  updateCyclePricing,
  updateCyclePlayers,
  prepareForPayment,
  showModal
}

const mapStateToProps = state => {
  return {
    products: state.products.list,
    categories: state.categories.list,
    pricings: state.pricings.list,
    currentPricing: state.pricings.currentPricing,
    transaction: state.transactions.currentTransaction,
    players: state.players.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(TableComponent)



// WEBPACK FOOTER //
// ./src/routes/Table/containers/TableContainer.js